import { EnumCouponError } from "../enums/EnumCouponError";
import { JsonCoupon } from "../json-data-types/JsonCoupon";
import { RequestMaker } from "./RequestMaker";


const filename = 'ServerCoupons'
export module ServerCoupons{


    export async function getAsync(code:string, email?:string, phone?:string){
        const result = await RequestMaker.sendWebsocketJsonRequestAsync<JsonCoupon>({
            query: 'coupon-get',
            params: {code, email, phone}
        }, filename)
        return result
    }

    export async function applyCouponToAnonymousBasketAsync(p:{couponCode:string, couponCodesInBasket:string[]}){
        const result = await RequestMaker.sendWebsocketJsonRequestAsync({
            query: 'basket-apply-coupon-for-anonymous',
            params: p
        }, filename)
        return result as JsonCoupon
    }

    export function getErrorMessageForCouponError(error:EnumCouponError|string){
        if(error.startsWith('Промокод')) return error // Промокод ${coupon.code} нельзя использовать вместе с другими промокодами
        // switch(error){
        //     case EnumCouponError.BadUserId:
        //         return 'Bad user id'
        //     case EnumCouponError.BadUserType:
        //         return 'Bad user type'
        //     case EnumCouponError.AlreadyUsedByUserId:
        //         return 'Already used by user id'
        //     case EnumCouponError.AlreadyUsedByPhoneOrEmail:
        //         return 'Already used by phone or email'
        //     case EnumCouponError.NotFound:
        //         return 'Coupon not found'
        //     case EnumCouponError.AlreadyApplied:
        //         return 'Coupon already applied'
        //     case EnumCouponError.ZeroDiscount:
        //         return 'Zero discount'
        //     case EnumCouponError.EmptyCode:
        //         return 'Empty code'
        //     case EnumCouponError.Outdated:
        //         return 'Outdated'
        //     case EnumCouponError.Unpublished:
        //         return 'Unpublished'
        //     default:
        //         return 'Unknown error'
        // }
        return 'Такой промокод не найден или более не действителен!'
    }


}    

